import { Grid, Table, TableBody, TableContainer } from '@mui/material';
import { useState } from 'react';
import AppContainer from 'src/components/appComponents/AppContainer';
import AppTableToolbar from 'src/components/appComponents/table/AppTableToolbar';
import Scrollbar from 'src/components/scrollbar';
import {
  TableHeadCustom,
  TablePaginationCustom,
  TableSkeleton,
  useTable,
} from 'src/components/table';
import { useGetAllCSVFileTrackerQuery } from 'src/graphql';
import { paths } from 'src/routes/paths';
import CSVFileTrackerTableRow from 'src/sections/csvFileTracker/CSVFileTrackerTableRow';
import { CSV_File_Tracker_TABLE_HEAD } from 'src/utils/tables-headers';

export default function CSVFileTrackerPage() {
  const table = useTable();
  const [search, setSearch] = useState({ subject: '', status: '' });

  const { data, isLoading } = useGetAllCSVFileTrackerQuery({
    offset: table.offset,
    limit: table.rowsPerPage,
  });

  return (
    <AppContainer
      pageTitle="CSVFileTracker"
      routeLinks={[{ name: 'Help Center' }, { name: 'CSVFileTracker' }]}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <AppTableToolbar
            tableName="CSVFileTracker"
            path={paths.dashboard.helpCenter.csvFileTracker}
            permissionName={undefined}
            setSearch={setSearch}
          />
        </Grid>
        <Grid item xs={12}>
          <TableContainer>
            <Scrollbar>
              <Table>
                <TableHeadCustom headLabel={CSV_File_Tracker_TABLE_HEAD} />
                <TableBody>
                  {isLoading
                    ? [...Array(table.rowsPerPage)].map((i, index) => (
                        <TableSkeleton key={index} sx={{ height: 80 }} />
                      ))
                    : data?.youtube_csv_files?.map((row) => (
                        <CSVFileTrackerTableRow key={row.id} row={row as any} />
                      ))}
                </TableBody>
              </Table>
            </Scrollbar>
          </TableContainer>
          {data && (
            <TablePaginationCustom
              count={data?.youtube_csv_files_aggregate?.aggregate?.count ?? 0}
              page={table.page}
              rowsPerPage={table.rowsPerPage}
              onPageChange={table.onChangePage}
              onRowsPerPageChange={table.onChangeRowsPerPage}
            />
          )}
        </Grid>
      </Grid>
    </AppContainer>
  );
}
